// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import { StorageFilterEnum } from '@Hooks/useStoragePage';
import client from '@Client';
import RouteBuilder from '@Services/RouteBuilder';
import { RouteType } from '@Types';
import { THLayout } from '@Molecules/THLayout';
import useConfigList from '@Hooks/useConfigList';
import { AuditOutput, ObjectTypeV1 } from 'thehive-sdk';
import { AuditList } from '@Organisms/Audit/AuditList/AuditList';
import { ICONS } from '@Constants/iconsApp';

const CaseHistoryList = (): ReactElement => {
    const { caseId } = useParams<{ caseId: string }>();

    const config = useConfigList<AuditOutput['base']>({
        selector: {
            head: [{ name: 'listAuditFromObject', idOrName: caseId, id: true }],
            name: `list-audit-from-case-${caseId}`,
            sort: ['-_createdAt'],
        },
        controller: client.CaseController,
        storageId: StorageFilterEnum.CASE_HISTORY,
        objectType: ObjectTypeV1.AUDIT,
        streamRootId: caseId,
        streamObjectType: ObjectTypeV1.CASE,
    });

    return (
        <THLayout>
            <THLayout.Content>
                <AuditList config={config} />
            </THLayout.Content>
        </THLayout>
    );
};

export const Route: RouteType = {
    menu: {
        icon: <ICONS.ReadOutlined />,
        label: 'case.layout.nav-bar.history',
    },
    path: RouteBuilder.compute('cases.history'),
    content: <CaseHistoryList />,
    exact: true,
    space: ['user'],
    breadcrumb: { label: 'breadcrumb.case.history' },
};
